import React from 'react';
import { Page } from '../Page';
import { Dumbbell, TrendingUp, Zap } from 'lucide-react';
export function SupplementAshwagandhaMuscle() {
  return <Page pageNumber={28} variant="light" data-id="element-3333" data-mp="egvlzo4yut1o">
      <div className="flex h-full gap-10" data-id="element-3334" data-mp="ag3aspcjae2r">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3335" data-mp="5hibcs53vyfd">
          <img src="https://cdn.magicpatterns.com/uploads/d3YyBiJkGkHonv19FV4VGU/pasted-image.png" alt="Thorne Ashwagandha" className="w-full max-w-[280px] object-contain" data-id="element-3336" data-mp="5jlaq2s5f3wr" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3337" data-mp="tefnum6kg83m">
          <div className="mb-6 pt-4" data-id="element-3338" data-mp="td4jol97kybz">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3339" data-mp="oh5z78r040gu">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3340" data-mp="1lxuzuz47swon">
              Ashwagandha
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3341" data-mp="1ua312x7jpu72">
              Support testosterone and lean muscle retention
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3342" data-mp="1z8ebpa5o08qc" />
          </div>

          <div className="mb-8" data-id="element-3343" data-mp="1liatcu9woz66">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3344" data-mp="1lh96ztnfwq95">
              Why It Matters for Exercise on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3345" data-mp="1bj22wbe922ok">
              Research shows ashwagandha supports healthy testosterone levels,
              which promotes lean muscle retention during weight loss, a
              critical concern on GLP-1 medications where up to 30-40% of weight
              lost can be lean mass. By modulating cortisol (which has an
              inverse relationship with testosterone), ashwagandha creates a
              more favorable hormonal environment for building and preserving
              muscle.
            </p>
          </div>

          <div className="mb-8" data-id="element-3346" data-mp="dqbw61op97mr">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3347" data-mp="dqlmjqdnpgsz">
              Key Benefits for Exercise
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3348" data-mp="8stwz30hi6ry">
              <li className="flex gap-2" data-id="element-3349" data-mp="4pxc15nh1yku">
                <TrendingUp className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3350" data-mp="3vvf5xzpm27ti" />
                <span data-id="element-3351" data-mp="3vxi6vesaxld0">
                  Supports healthy testosterone levels, promoting muscle protein
                  synthesis and lean mass retention
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3352" data-mp="sgt84eyynfxw">
                <Dumbbell className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3353" data-mp="nngiq2mgj543" />
                <span data-id="element-3354" data-mp="iowws27v5tbq">
                  Enhances strength, power output, and exercise recovery in
                  clinical studies
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3355" data-mp="1g6ds916uoj8r">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3356" data-mp="1bd14et9zwgh2" />
                <span data-id="element-3357" data-mp="1iopa3r8gibjn">
                  Lowers cortisol, reducing the catabolic hormone that breaks
                  down muscle tissue
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3358" data-mp="1npwhhp6ot8ps">
                <span className="text-tealslate shrink-0" data-id="element-3359" data-mp="1smdgjeffd7hn">•</span>
                <span data-id="element-3360" data-mp="1sp9gt9eqw899">
                  Shoden® extract at 35% withanolide glycosides, clinically
                  effective at just 1 capsule per day
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 mb-6" data-id="element-3361" data-mp="26mefgoc4q4uh">
            <p className="text-xs text-[#3B3B3B] leading-[1.6] italic" data-id="element-3362" data-mp="26kbjzos7jjid">
              Pair with creatine and adequate protein intake for the strongest
              muscle-preservation strategy during GLP-1 weight loss.
            </p>
          </div>

          <div className="mt-auto" data-id="element-3363" data-mp="2kf483bm5y80k">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3364" data-mp="2kbzvbpumu3ya">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3365" data-mp="2pdp4t127i9k9">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3366" data-mp="27otriu35olhb">
                <strong data-id="element-3367" data-mp="27obys7fpcpe5">1 capsule daily</strong>. Can be taken morning or
                evening
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3368" data-mp="2lfgnwflg1za8">
                30 capsules per bottle • Shoden® ashwagandha extract
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3369" data-mp="1sqt1ggoyl3v3">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3370" data-mp="1ste59b8thtvh" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3371" data-mp="1xqea5itxkql0">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}